/*
* Copyright (C) GMS Inc - All Rights Reserved
* This file is part of GMSCloud. - Proprietary and confidential
* Unauthorized copying of this file, via any medium is strictly prohibited
* 
* Created on   :30/05/23
* @author      :Asish P Saji
* @since       : 0.0.1
* Requirement# :
* Purpose      : for adding tenant
* -----------------------------------------------------------------------------0
* Revision History
* -----------------------------------------------------------------------------
* Requirement/
* Issue/WorkItem |   DATE    |   AUTHOR  |   DESCRIPTION OF CHANGE
* -----------------------------------------------------------------------------
* 1548         |  5/4/24    |   Nandha      |  Otp Generator toast message removed and dialog implemented
*
*
*/
import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { Alert, Button, Card, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, Grid, Snackbar, Typography, useMediaQuery, useTheme, CircularProgress, Backdrop, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import { GoogleMap, useJsApiLoader, MarkerF, StandaloneSearchBox } from '@react-google-maps/api';
import { Stack } from '@mui/system';
import { useOidcAccessToken } from "@axa-fr/react-oidc";
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Header from '../Header';
import { tokens } from '../../hooks/theme';
import { useLocation, useNavigate } from 'react-router-dom';
import './TenantProvisioningPage.scss';
import { createTenantProvision, updateTenantProvision } from '../../services/TenantService';
import gmslogo from "../../assets/logo.gif";
import { useState } from 'react';
import { manualGeocode, isGooglePlacesAvailable } from '../../utils/mapUtil';

const containerStyle = {
    width: '100%',
    height: '300px'
};
const libraries: any = ['places'];

const TenantProvisioning: React.FC = () => {
    let location = useLocation()
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyBHfzWHT7qgElExVxQzVRhCJtW1Z6YRILw",
        libraries
    })
    const [map, setMap] = React.useState<google.maps.Map | null>(null);
    const { accessToken, accessTokenPayload } = useOidcAccessToken();
    const [subscriberId, setSubscriberId] = React.useState<any>([] as any[]);
    const [open, setOpen] = React.useState(false);
    const [count, setCount] = React.useState(0);
    const [MobileNumberValid, setMobileNumberValid] = React.useState(true);
    const [confirmationDialog, setConfirmationDialog] = React.useState<string | null>(null);   
    const [confirmationUpdate, setConfirmationUpdate] = React.useState(false);
    const [message, setMessage] = React.useState<any>({

        country: '',
        zipcode: '',
        state: '',
        address: '',
        city: '',
        phoneNo: '',
        email: '',
        displayName: '',

    });
    const [loading, setLoading] = React.useState(false);
    const [tenantData, setTenantData] = React.useState<any>({
        address: "",
        name: "",
        country: "",
        zipcode: '',
        state: "",
        city: "",
        location: "",
        status: "Active",
        customerUid: "",
        phoneNo: '',
        email: '',
        displayName: '',
        tenantId: ''

    });

    const handleCreateTenant = () => {
        let validated = validation();
        if (validated === true) {
            setLoading(true);

            createTenantProvision(tenantData, accessToken).then(res => {
                const updatedTenantData = {
                    ...tenantData,
                    tenantId: res?.data, // Assuming res.data contains tenantId
                    name: res?.data // Assuming res.data contains name
                };
                setTenantData(updatedTenantData);

                if (res.ok === true) {
                    navigate("/tenantuser", { state: { tenantData: updatedTenantData } });
                }
            });
        } else {
            // Handle validation error, e.g., show error message to user
            //console.log("Validation failed");
        }
    }
    const cancel = () => {
        navigate('/tenant')
    }
    const componentData = React.useRef<any>()
    const theme = useTheme();
    const smScreen = useMediaQuery(theme.breakpoints.up("sm"));
    const colors = tokens(theme.palette.mode);
    let navigate = useNavigate();
    const [selectedFile, setSelectedFile] = React.useState<File | string>();
    const [image, setImage] = React.useState<any>(null);
    const [toastMessage, setToastMessage] = React.useState('');
    let tenantDataObject = location.state?.row;
    const inputRef = React.useRef<any>();
    const [success, setSuccess] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [noChange, setNoChange] = React.useState(false);
    const [successType, setSuccessType] = React.useState('');

    const convertLocation = (locationString: any) => {
        if (!locationString) {
            return { lat: 0, lng: 0 };
        }
        let locationObject: any = {};
        let string = locationString;
        let st = string.split(",");
        locationObject["lat"] = Number(st[0]);
        locationObject["lng"] = Number(st[1]);
        return locationObject;
    };

    const onLoad = React.useCallback(function callback(map: any) {
        const bounds = new window.google.maps.LatLngBounds(componentData.current);
        map.fitBounds(bounds);
        setMap(map);
    }, []);

    const onUnmount = React.useCallback(function callback(map: any) {
        setMap(null)
    }, [])

    const onClick = (e: google.maps.MapMouseEvent) => {
        componentData.current = { lat: e.latLng?.lat(), lng: e.latLng?.lng() };
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ location: componentData.current }).then((response) => {
        if (response.results[0]) {
            const locationObject: any = {};

            response.results[0].address_components.forEach((component) => {
            const { long_name, types } = component;

            if (
                types.includes("street_number") ||
                types.includes("sublocality_level_1") ||
                types.includes("sublocality_level_2") ||
                types.includes("route") ||
                types.includes("plus_code") ||
                types.includes("landmark") ||
                types.includes("premise")
            ) {
                locationObject.address =
                long_name +
                (locationObject.address ? "   " + locationObject.address : "");
            } else if (types.includes("locality")) {
                locationObject.city = long_name;
            } else if (types.includes("administrative_area_level_1")) {
                locationObject.state = long_name;
            } else if (types.includes("country")) {
                locationObject.country = long_name;
            } else if (types.includes("postal_code")) {
                locationObject.zipCode = long_name;
            }
            });
            locationObject.location = Object.values(componentData.current).join(
            ",",
            );
            setTenantData({ ...tenantData, ...locationObject });
        }
        });
    };

    React.useEffect(() => {
        tenantDataObject = location.state?.row;
        setSubscriberId(tenantDataObject?.name);
        if (tenantDataObject !== undefined) {
            setTenantData(tenantDataObject);
            if (tenantDataObject?.location) {
                componentData.current = convertLocation(tenantDataObject?.location);
            }
        }
    }, []);

    const validateMobileNumber = (mobileNo) => {
        return /^\d{10}$/.test(mobileNo);
    };

    const inputchange = (e: any) => {
        const { name, value } = e.target;
        if (name === "alternatephoneNo" || name === "phoneNo" || name === "zipcode") {
            if (value.length > 10) return;
        }
        setTenantData({
            ...tenantData,
            [name]: value

        });
        if (name === 'phoneNo') {
            const isValidMobileNumber = validateMobileNumber(value);
            setMobileNumberValid(isValidMobileNumber);
        }
    };

    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    const validation = () => {
        let validated: any = true;

        if (tenantData.state === '') {
            // setMessage({...message,state:'Enter Your State'});
            message.state = 'Enter Your State';
            validated = false;

        }
        if (tenantData.city === '') {
            // setMessage({...message,city:'Enter Your City'});
            message.city = 'Enter Your City';
            validated = false;

        }
        if (tenantData.country === '') {
            //setMessage({...message,country:'Enter Your Country'});
            message.country = 'Enter Your Country';
            validated = false;

        }

        if (tenantData.zipcode === '') {
            // setMessage({...message,stories:'Enter Your Stories'});
            message.zipcode = 'Enter Your zipcode';
            validated = false;

        }
        if (tenantData.address === '') {
            // setMessage({...message,stories:'Enter Your Stories'});
            message.address = 'Enter Your address';
            validated = false;

        }

        if (!MobileNumberValid || tenantData.phoneNo === null || tenantData.phoneNo === "" || tenantData.phoneNo === undefined) {
            // setMessage({...message,stories:'Enter Your Stories'});
            message.phoneNo = 'Enter Your phone number';
            validated = false;

        }
        if (tenantData.displayName === '') {
            // setMessage({...message,stories:'Enter Your Stories'});
            message.displayName = 'Enter Your display name';
            validated = false;

        }
        if ((tenantData.email === '') || (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(tenantData.email))) {
            // setMessage({...message,stories:'Enter Your Stories'});
            message.email = 'Enter Your email';
            validated = false;

        }
        return validated;
    }

    const handleAlertClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        setSuccess(false);
        setError(false);
        setNoChange(false)
    }
    const handleNoChange = (event?: React.SyntheticEvent | Event, reason?: string) => {

        setNoChange(false)

    }
    const handleNextChange = (event?: React.SyntheticEvent | Event, reason?: string) => {

        setNoChange(false)
        navigate("/tenantuser", { state: { tenantData } });

    }

    const updateHandleSubmit = async () => {
        setCount(count + 1);
        let validated = validation();
        let formData = new FormData();
        formData.append("file", image);

        if (tenantDataObject.address === tenantData?.address && tenantDataObject.displayName === tenantData?.displayName && tenantDataObject?.name === tenantData?.name && tenantDataObject.country === tenantData?.country
            && tenantDataObject.zipcode === tenantData?.zipcode && tenantDataObject.state === tenantData?.state && tenantDataObject.city === tenantData?.city
            && tenantDataObject.phoneNo === tenantData?.phoneNo && tenantDataObject?.description === tenantData?.description) {
            setNoChange(true);

        }
        else {
            if (validated === true) {
                if (tenantData?.location != null) {
                    if (typeof (tenantData?.location) != "string") {
                        let data = tenantData;
                        data.location = Object.values(tenantData?.location).join(",")
                        setTenantData(data);
                    }
                }
                let result = await updateTenantProvision(tenantDataObject.id, tenantData, accessToken);

                // let uploadResult = await editAssetDocument(formData, assetId, accessToken);
                if (result.status === 200 || result.status === 201) {
                    setSuccessType('update');
                    setSuccess(true);
                    navigate("/tenantuser", { state: { tenantData } });
                }
                else {
                    setError(true);
                }
            }

        }
    };

    const getFile = (event: any) => {
        const file = event.target.files[0];
        setSelectedFile(URL.createObjectURL(file));
        setImage(file);
        if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                if (typeof reader.result === 'string') {
                    setTenantData({
                        ...tenantData,
                        tenantLogo: reader.result,

                    })
                }
            };
            reader.onerror = (error) => {
                console.error('Error occurred while reading the file:', error);
            };
        }

    };
    const handleCardClick = () => {
        const fileInput = document.getElementById("image-upload-input") as HTMLInputElement;
        fileInput.click();
    };

    const handlePlaceChanged = () => {
        const places: google.maps.places.PlaceResult[] | undefined = inputRef.current?.getPlaces?.();
        const place = places?.[0];
        if (!place) return;
        const fulladdress: string[] = [];
        let locationObject: any = {};
        if (place.address_components && place.address_components.length > 0) {
            place.address_components.forEach((address: any) => {
            if (
                address.types.includes("street_number") ||
                address.types.includes("sublocality_level_1") ||
                address.types.includes("sublocality_level_2") ||
                address.types.includes("route") ||
                address.types.includes("landmark") ||
                address.types.includes("premise")
            ) {
                fulladdress.push(address.long_name);
                locationObject["address"] = fulladdress.join(" ");
            } else if (address.types.includes("locality")) {
                locationObject["city"] = address.long_name;
            } else if (address.types.includes("administrative_area_level_1")) {
                locationObject["state"] = address.long_name;
            } else if (address.types.includes("country")) {
                locationObject["country"] = address.long_name;
            } else if (address.types.includes("postal_code")) {
                locationObject["zipcode"] = address.long_name;
            }
            });
            if (place.geometry?.location) {
            componentData.current = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
            };
            setTenantData({
                ...tenantData,
                zipcode: locationObject.zipcode || "",
                country: locationObject.country || "",
                address: locationObject.address || "",
                city: locationObject.city || "",
                state: locationObject.state || "",
                location: Object.values(componentData.current).join(","),
            });
            } else {
            setTenantData({
                ...tenantData,
                zipcode: locationObject.zipcode || "",
                country: locationObject.country || "",
                address: locationObject.address || "",
                city: locationObject.city || "",
                state: locationObject.state || "",
            });
            }
        }
    };

    const handleTenantUserPage = () => {
        setCount(count + 1);
        let formData = new FormData();
        formData.append("file", image);
        let validated = validation();
        if (validated === true) {
            handleCreateTenant();
        }
        else {
            console.log("not validated")
        }
    }

    const allowOnlyNumbers = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (!/^[0-9]$/.test(e.key) && e.key.length === 1) {
            e.preventDefault();
        }
    };

    const isSuccessMessage = toastMessage === 'Inserted Successfully' || toastMessage === 'Updated Successfully';

    const handleManualGeocode = async () => {
        try {
        const result = await manualGeocode(tenantData);
        setTenantData((prev) => ({
            ...prev,
            location: result.location,
        }));

        if (map) {
            map.panTo(result.geometry);
            map.setZoom(20);
        }
        } catch (err) {
        console.error(err);
        }
    };

    React.useEffect(() => {
        if (!isLoaded) return;
        const hasMinimumData = tenantData.country &&
            (tenantData.city  || tenantData.state || tenantData.zipcode || tenantData.address);

        if (!hasMinimumData) return;

        const fullAddress = [
            tenantData.address,
            tenantData.city,
            tenantData.state,
            tenantData.zipcode,
            tenantData.country,
        ].filter(part => part && part.trim() !== "").join(", ");

        getPlaceDetails(fullAddress);

    }, [
        isLoaded,
        tenantData.address,
        tenantData.city,
        tenantData.state,
        tenantData.zipcode,
        tenantData.country,
    ]);

    const getPlaceDetails = (address: string) => {
        try {
            if (!isLoaded) {
                console.warn("Google Maps API not loaded yet.");
                return;
            }

            if (!isGooglePlacesAvailable()) {
                console.error("Location service temporarily unavailable.");
                return;
            }

            if (!address || address.trim() === "") {
                console.warn("Empty address passed to getPlaceDetails.");
                return;
            }

            const geocoder = new google.maps.Geocoder();

            geocoder.geocode({ address }, (results, status) => {
                if (
                    status === google.maps.GeocoderStatus.OK &&
                    results?.[0]
                ) {
                    const geometry = results[0].geometry.location;
                    const lat = geometry.lat();
                    const lng = geometry.lng();

                    componentData.current = { lat, lng };

                    setTenantData((prevData) => ({
                        ...prevData,
                        location: `${lat},${lng}`,
                    }));

                    if (map) {
                        map.panTo({ lat, lng });
                        map.setZoom(15);
                    }
                } else {
                    console.warn(
                        "Geocode lookup failed. Status:", status,
                        "Address:", address
                    );
                }
            });

        } catch (error) {
            console.error("Error in getPlaceDetails:", error);
        }
    };

    return (
        <>
            <Grid container justifyContent="center" alignItems="center" >
                <Grid item xs={12} sm={12}>
                    <Box
                        display={smScreen ? "flex" : "block"}
                        flexDirection={smScreen ? "row" : "column"}
                        alignItems={smScreen ? "center" : "start"}
                        m="1px 0"
                    >
                        <Grid item sm={6}>
                            {tenantDataObject ? <Header title="Edit  Tenant provisioning" subtitle={""} /> : <Header title="Create Tenant provisioning" subtitle={""} />}
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
            <Snackbar open={open} autoHideDuration={1000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} sx={{ paddingTop: 6 }}>
                <Alert onClose={handleClose} severity={isSuccessMessage ? 'success' : 'warning'} sx={{ width: '100%' }} >
                    {toastMessage}
                </Alert>
            </Snackbar>
            <Grid container justifyContent="center" alignItems="center" rowSpacing={2} columnSpacing={{ xs: 4, sm: 2, md: 3 }}>
                <Grid item xs={12} sm={12}>
                    <Box>
                        <Card className='POCard' variant="outlined" sx={{ p: 3, maxWidth: "1500px" }} >
                            <Grid container spacing={2} columns={13} className='tenantCard'>
                                {(tenantDataObject === null || tenantDataObject === undefined) && <Grid item xs={13} sm={13} md={3} lg={3} xl={3}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} className={loading ? 'blur-background' : ''}>
                                            <Backdrop open={loading} style={{ zIndex: 9999 }}>
                                                {/* <CircularProgress color="inherit" />Loading... */}
                                                <Grid container alignItems="center" justifyContent="center">
                                                    <Grid item md={12} style={{ textAlign: 'center' }}>
                                                        <img src={gmslogo} alt="Image" className="topBarLogo" />
                                                    </Grid>
                                                    <Grid item md={12} style={{ textAlign: 'center' }}>
                                                        <Typography className="loading" variant='h4' color="blue">Please wait...</Typography>
                                                    </Grid>
                                                </Grid>
                                            </Backdrop>

                                            <Card variant="outlined" className='tenantImageUpload'
                                                onClick={handleCardClick}
                                            >
                                                <label>
                                                    {typeof selectedFile === "string" ? (
                                                        <img src={selectedFile} alt="Selected" className='provisioningImage' />
                                                    ) : (
                                                        <Stack sx={{ textAlign: 'center', cursor: "pointer", }}>
                                                            <Typography>
                                                                <AddIcon />
                                                            </Typography>
                                                            <Typography>
                                                                Click to Upload company logo
                                                            </Typography>
                                                        </Stack>
                                                    )}
                                                </label>
                                                <input
                                                    type="file"
                                                    id="image-upload-input"
                                                    onChange={(e) => getFile(e)}
                                                    style={{ display: "none" }}
                                                    accept="image/*"
                                                />

                                            </Card>
                                        </Grid>
                                    </Grid>
                                </Grid>}
                                <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}> <Typography className='assetSubHeader' fontSize={20} sx={{ color: colors.greenAccent[1000] }}>Enter Tenant Information</Typography></Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                error={(tenantData.displayName === '' && count !== 0)}
                                                id="demo-helper-text-aligned"
                                                label="Company Name"
                                                name="displayName"
                                                size="small"
                                                fullWidth
                                                required
                                                value={tenantData.displayName}
                                                helperText={(tenantData.displayName === '' && count !== 0) ? message.displayName : null}
                                                onChange={(e) => inputchange(e)}
                                            /></Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                // error={(tenantData.phoneNo === '' && count !== 0) }
                                                error={(!MobileNumberValid && count !== 0) || (tenantData.phoneNo === '' && count !== 0)}
                                                helperText={tenantData.phoneNo !== "" && !MobileNumberValid ? "Invalid mobile number" : null}
                                                id="demo-helper-text-aligned"
                                                label="Mobile No"
                                                name="phoneNo"
                                                size="small"
                                                fullWidth
                                                required
                                                value={tenantData.phoneNo}
                                                onKeyDown={allowOnlyNumbers}
                                                onChange={(e) => inputchange(e)}
                                                // type="number"
                                                inputProps={{
                                                    maxLength: 10,
                                                }}
                                            /></Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                // error={(tenantData.alternatephoneNo === '' && count !== 0)}
                                                id="demo-helper-text-aligned"
                                                label="Secondary Mobile No"
                                                name="alternatephoneNo"
                                                size="small"
                                                fullWidth
                                                value={tenantData.alternatephoneNo}
                                                helperText={(tenantData.alternatephoneNo === '' && count !== 0) ? message.alternatephoneNo : null}
                                                onChange={(e) => inputchange(e)}
                                                onKeyDown={allowOnlyNumbers}
                                            /></Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                error={(tenantData.email === '' && count !== 0) || (count !== 0 && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(tenantData.email))}
                                                id="demo-helper-text-aligned"
                                                label="Email"
                                                name="email"
                                                size="small"
                                                fullWidth
                                                required
                                                value={tenantData.email}
                                                helperText={
                                                    tenantData.email === '' && count !== 0
                                                        ? message.email
                                                        : !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(tenantData.email)
                                                            ? 'Please enter a valid email address'
                                                            : null
                                                }
                                                onChange={(e) => inputchange(e)}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            {isLoaded
                                                &&
                                                <StandaloneSearchBox
                                                    onLoad={ref => inputRef.current = ref}
                                                    onPlacesChanged={handlePlaceChanged}
                                                >
                                                    <TextField
                                                        error={(tenantData.address === '' && count !== 0)}
                                                        id="Street address"
                                                        label="Street Address"
                                                        name="address"
                                                        size="small"
                                                        fullWidth
                                                        value={tenantData.address}
                                                        required
                                                        helperText={(tenantData.address === '' && count !== 0) ? message.address : null}
                                                        onChange={(e) => inputchange(e)}
                                                        onBlur={handleManualGeocode}
                                                    />
                                                </StandaloneSearchBox>}
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                error={(tenantData.city === '' && count !== 0)}
                                                id="demo-helper-text-aligned"
                                                label="City"
                                                size="small"
                                                fullWidth
                                                required
                                                name="city"
                                                value={tenantData.city}
                                                helperText={(tenantData.city === '' && count !== 0) ? message.city : null}
                                                onChange={(e) => inputchange(e)}
                                                onBlur={handleManualGeocode}

                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                error={(tenantData.state === '' && count !== 0)}
                                                id="demo-helper-text-aligned-no-helper"
                                                label="State"
                                                size="small"
                                                fullWidth
                                                name="state"
                                                required
                                                value={tenantData.state}
                                                onChange={(e) => inputchange(e)}
                                                helperText={(tenantData.state === '' && count !== 0) ? message.state : null}
                                                onBlur={handleManualGeocode}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                error={(tenantData.country === '' && count !== 0)}
                                                id="demo-helper-text-aligned-no-helper"
                                                label="Country"
                                                size="small"
                                                fullWidth
                                                value={tenantData.country}
                                                helperText={(tenantData.country === '' && count !== 0) ? message.country : null}
                                                name="country"
                                                required
                                                onChange={(e) => inputchange(e)}
                                                onBlur={handleManualGeocode}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                error={(tenantData.zipcode === '' && count !== 0)}
                                                id="demo-helper-text-aligned-no-helper"
                                                label="Zip Code"
                                                size="small"
                                                name="zipcode"
                                                fullWidth
                                                value={tenantData.zipcode}
                                                required
                                                helperText={(tenantData.zipcode === '' && count !== 0) ? message.zipcode : null}
                                                onChange={(e) => inputchange(e)}
                                                onBlur={handleManualGeocode}
                                                onKeyDown={allowOnlyNumbers}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                error={(tenantData.description === '' && count !== 0)}
                                                id="demo-helper-text-aligned-no-helper"
                                                label="Description"
                                                size="small"
                                                name="description"
                                                fullWidth
                                                value={tenantData.description}
                                                helperText={(tenantData.description === '' && count !== 0) ? message.description : null}
                                                onChange={(e) => inputchange(e)}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} sx={{ marginTop: 1 }}>
                                <Grid item xs={12}>
                                    <Stack direction={'row'}>
                                        <Typography><MapOutlinedIcon fontSize='small' /></Typography>
                                        <Typography>Choose from MAP </Typography>
                                    </Stack>
                                </Grid>
                                <Grid item xs={13}>
                                    {isLoaded ? (
                                        <GoogleMap
                                            mapContainerStyle={containerStyle}
                                            center={convertLocation(tenantData?.location)}
                                            zoom={30}
                                            onLoad={onLoad}
                                            onUnmount={onUnmount}
                                            onClick={onClick}
                                            >
                                            <MarkerF
                                                position={convertLocation(tenantData?.location)}
                                            ></MarkerF>

                                            <></>
                                            </GoogleMap>
                                    ) : <></>}
                                </Grid>
                            </Grid >
                            <Grid container spacing={2} justifyContent="flex-end" mt={2}>
                                {tenantDataObject !== null && tenantDataObject !== undefined ? (<Grid item mt={1}>
                                    <Button className='successButton' variant="contained" size="medium" onClick={updateHandleSubmit}>
                                        Next
                                    </Button>
                                </Grid>
                                ) : (

                                    <Grid item mt={1}>
                                        <Button className='successButton' variant="contained" size="medium" onClick={handleTenantUserPage}>
                                            Next
                                        </Button>
                                    </Grid>
                                )}
                                {/* )} */}
                                <Grid item>
                                    <Button className='dangerButton' variant="contained" size="medium" onClick={cancel}>
                                        Cancel
                                    </Button>
                                </Grid>
                            </Grid>

                        </Card>
                    </Box>
                    <Dialog open={success} >
                        <DialogTitle className='success'>
                            <Box paddingLeft={8} paddingRight={8}>
                                <Typography textAlign={'center'}>
                                    <CheckCircleOutlinedIcon sx={{ fontSize: "50px", color: "white" }} /></Typography>
                                <Typography textAlign={'center'} color='white' fontSize={'20px'} fontWeight={'400'} >
                                    Success
                                </Typography>
                            </Box>
                        </DialogTitle>
                        <Box paddingLeft={8} paddingRight={8}>
                            <DialogContent >
                                <DialogContentText textAlign={'center'} fontSize={'18px'} fontWeight={'500'}>   {successType === 'save' ? 'Asset added Successfully' : 'Asset Updated Successfully'}</DialogContentText>
                            </DialogContent>
                            <DialogActions style={{ justifyContent: "center" }}>
                                <Button variant='contained' className="successButton" onClick={handleAlertClose}>Ok</Button>
                            </DialogActions>
                        </Box>
                    </Dialog>

                    <Dialog open={error} >
                        <DialogTitle className='error'>
                            <Box paddingLeft={8} paddingRight={8}>
                                <Typography textAlign={'center'}>
                                    <CancelOutlinedIcon sx={{ fontSize: "50px", color: "white" }} /></Typography>
                                <Typography textAlign={'center'} color='white' fontSize={'20px'} fontWeight={'400'} >
                                    Error
                                </Typography>
                            </Box>
                        </DialogTitle>
                        <Box paddingLeft={8} paddingRight={8}>
                            <DialogContent >
                                <DialogContentText textAlign={'center'} fontSize={'18px'} fontWeight={'500'}>{successType === 'save' ? 'Save failed. Please try again.' : 'Update failed. Please try again.'}</DialogContentText>
                            </DialogContent>
                            <DialogActions style={{ justifyContent: "center" }}>
                                <Button variant='contained' sx={{ backgroundColor: "#df3333ed" }} onClick={handleAlertClose}>Close</Button>
                            </DialogActions>
                        </Box>

                    </Dialog>


                    <Dialog open={noChange} >
                        <DialogTitle className='success' sx={{ backgroundColor: "rgb(255,193,0) !important" }}>
                            <Box paddingLeft={8} paddingRight={8}>
                                <Typography textAlign={'center'}>
                                    <InfoOutlinedIcon sx={{ fontSize: "50px", color: "white" }} /></Typography>
                            </Box>
                        </DialogTitle>
                        <Box paddingLeft={8} paddingRight={8}>
                            <DialogContent >
                                <DialogContentText textAlign={'center'} fontSize={'18px'} fontWeight={'500'}>Are you sure you dont want to change any data in tenant provisioning</DialogContentText>
                            </DialogContent>
                            <DialogActions style={{ justifyContent: "center" }}>
                                <Button variant='contained' className="NoChangeButton"  color='error' onClick={handleNoChange}>Cancel</Button>
                                <Button variant='contained' className="NoChangeButton" onClick={handleNextChange}>ok</Button>

                            </DialogActions>
                        </Box>
                    </Dialog>
                </Grid>
            </Grid>

        </>
    );
}

export default TenantProvisioning;